import React from 'react'

const SvgSendFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.943 2.301c.592-.365 1.242-.398 1.951-.1l16.026 8.012c.72.447 1.08 1.043 1.08 1.79 0 .747-.36 1.343-1.08 1.79L4.894 21.801c-.706.297-1.356.262-1.95-.105-.595-.368-.91-.93-.944-1.685v-5.01l7.268-2.908a.1.1 0 000-.186L2 9V3.991c.038-.76.352-1.324.943-1.69z'
    />
  </svg>
)

export default SvgSendFilled
